import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Avatar, Chip, IconButton, Tooltip } from '@mui/material';
import {
  Article as ArticleIcon,
  Visibility as VisibilityIcon,
  Feedback as FeedbackIcon,
} from '@mui/icons-material';
import { getAllWritings, deleteWriting } from '../../api/writingApi';
import { GenericListPage } from '../../components/templates';
import ModernButton from '../../components/common/ModernButton';

const WritingList = () => {
  const navigate = useNavigate();

  const columns = [
    {
      field: 'label',
      headerName: 'Writing Title',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              backgroundColor: params.row.isPractice ? 'info.main' : 'success.main',
              width: 32,
              height: 32,
              fontSize: '0.875rem',
            }}
          >
            {params.row.isPractice ? 'P' : 'R'}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value || 'N/A'}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 0.8,
      renderCell: (params) => (
        <Chip
          label={params.row.isPractice ? 'Practice' : 'Real Exam'}
          color={params.row.isPractice ? 'info' : 'success'}
          size="small"
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ),
    },
  ];

  const extraActions = (row) => (
    <Tooltip title="Questions">
      <IconButton
        onClick={() => navigate(`/writings/${row._id}/questions`)}
        size="small"
        sx={{ color: 'warning.main', '&:hover': { backgroundColor: 'warning.50' } }}
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  const renderExtraButtons = () => (
    <ModernButton
      onClick={() => navigate('/writing-answers')}
      startIcon={<FeedbackIcon />}
      variant="outlined"
    >
      View Feedback
    </ModernButton>
  );

  return (
    <GenericListPage
      title="Writing Management"
      subtitle="Create and manage writing tasks and questions"
      icon={<ArticleIcon />}
      entityName="Writing"
      columns={columns}
      fetchData={getAllWritings}
      deleteItem={deleteWriting}
      createPath="/writings/new"
      editPath="/writings"
      extraActions={extraActions}
      renderExtraButtons={renderExtraButtons}
      tabs={[
        { label: 'Real Exams', color: 'success' },
        { label: 'Practice Exams', color: 'info' },
      ]}
      filterKey="isPractice"
      filterValues={[false, true]}
    />
  );
};

export default WritingList;
